import ls from 'localstorage-slim';
export default {
  userIsPartTime(state) {
    return state.isPartTime || localStorage.getItem('isPartTime') || null;
  },
  userUserName(state) {
    return state.userName || localStorage.getItem('userName') || null;
  },
  userPersonID(state) {
    return state.personID || localStorage.getItem('personID');
  },
  userLastLoginDateTime(state) {
    return (
      state.lastLoginDateTime ||
      localStorage.getItem('lastLoginDateTime') ||
      null
    );
  },
  userID(state) {
    return state.userID || localStorage.getItem('userID') || null;
    // return state.userID;
  },
  userFirstName(state) {
    return `${state.firstName || localStorage.getItem('firstName') || ''}`;
  },
  userLastName(state) {
    return `${state.lastName || localStorage.getItem('lastName') || ''}`;
  },
  userHasUnseenMessage(state) {
    return `${
      state.hasUnseenMessage || localStorage.getItem('hasUnseenMessage') || ''
    }`;
  },
  userFullName(state) {
    return `${state.firstName || localStorage.getItem('firstName') || ''} ${
      state.lastName || localStorage.getItem('lastName') || ''
    }`;
    // return `${state.firstName} ${state.lastName}`;
  },
  userToken(state) {
    // eslint-disable-next-line
    let token = getCookie('token');
    return state.token || token || null;
  },
  userrefreshToken(state) {
    // eslint-disable-next-line
    let refreshToken = getCookie('refreshToken');
    return state.refreshToken || refreshToken || null;
    // return state.token;
  },
  userRequireChangePassword(state) {
    return (
      state.requireChangePassword ||
      localStorage.getItem('requireChangePassword') ||
      null
    );
  },
  isAuthenticated(state) {
    if (!state.token) {
      // return !!localStorage.getItem('token');
      // eslint-disable-next-line
      return !!getCookie('token');
    }
    return !!state.token;
  },
  userUnseenNotifications(state) {
    if (state.userUnseenNotifications) {
      if (state.userUnseenNotifications.length > 0) {
        return state.userUnseenNotifications;
      }
    }
    let unseenNotificationsFromStorage = JSON.parse(
      ls.get('userUnseenNotifications', { decrypt: true })
    );
    if (unseenNotificationsFromStorage) {
      if (unseenNotificationsFromStorage.length == 0) {
        return state.userUnseenNotifications;
      }
    } else return state.userUnseenNotifications;

    state.userUnseenNotifications = unseenNotificationsFromStorage;
    return state.userUnseenNotifications;
  },
};
